import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { type ReflectionSummary } from "../backend/api";
import { queryOptions_reflection } from "../query/functions/reflection/all";
import { ReflectionService } from "../services/reflection.service";
import { authSelectors } from "../store/auth";
import { useAuthStore } from "../store/auth";

export type ReflectionState = ReflectionSummary[];

interface ReflectionStateLoading {
	isLoading: true;
	data: undefined;
	service: undefined;
}

interface ReflectionStateLoaded {
	isLoading: false;
	data: ReflectionState;
	service: ReflectionService;
}

export type ReflectionStateResult = ReflectionStateLoading | ReflectionStateLoaded;

export function useReflection(): ReflectionStateResult {
	const isAuthenticated = useAuthStore(useShallow(authSelectors.isAuthenticated));

	const { data: reflectionState, isLoading } = useQuery({
		...queryOptions_reflection(),
		enabled: isAuthenticated,
	});

	const reflectionService = useMemo(
		() => (reflectionState ? new ReflectionService(reflectionState) : undefined),
		[reflectionState],
	);

	if (isLoading) {
		return { isLoading: true, data: undefined, service: undefined };
	}

	if (!reflectionState || !reflectionService) {
		return { isLoading: true, data: undefined, service: undefined };
	}

	return { isLoading: false, data: reflectionState, service: reflectionService };
}
